<template>
    <div class="flex flex-col md:flex-row w-full">
            <div class="w-full flex flex-col border-t-0 overflow-scroll">
            <span class="flex justify-end h-[60px]">
                <span v-if="(leaderboard === 'alltime' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">All Time Global Leaderboard</span>
                <span v-if="(leaderboard === 'monthly' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">Monthly Global Leaderboard</span>
                <span v-if="(leaderboard === 'weekly' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">Weekly Global Leaderboard</span>
                <span v-if="(leaderboard === 'daily' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">Daily Global Leaderboard</span>
                <span v-if="(leaderboard === 'previous_week' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">Previous Week Global Leaderboard</span>
                <span v-if="(leaderboard === 'previous_month' && leagueFilter == 'Leaderboard')" class="hidden md:flex lg:text-xl text-base font-semibold text-white mx-auto text-center mt-4 mb-4">Previous Month Global Leaderboard</span>
                <select v-if="leagueFilter == 'Leaderboard'" name="leaderboard" id="leaderboard" v-model="leaderboard" @change="changeLeaderboard" class="text-black text-xs h-8 rounded-md mr-2 my-auto mb-2">
                    <option value="previous_week">Previous Week</option>
                    <option value="previous_month">Previous Month</option>
                    <option v-if="$page.props.settings.site_name !== 'Racing League'" value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option v-if="$page.props.settings.site_name !== 'Racing League'" value="monthly">Monthly</option>
                    <option value="alltime">All Time</option>
                </select>
            </span>
                <div v-if="leagueFilter == 'Leaderboard'" class="overflow-scroll mb-10 lg:mb-0 p-3">
                    <table class=" text-white w-full overflow-scroll">
                        <thead class="bg-gray-700 rounded-md text-xl font-semibold">
                        <tr>
                            <th class="text-left pl-2 lg:pl-4 text-sm">Ranking</th>
                            <th class="lg:text-left text-sm">
                                Username
                            </th>
                            <th class="text-sm">Meetings Entered</th>
                            <th class="text-sm">Total Points</th>
                        </tr>
                        </thead>
                        <tbody class="text-lg overflow-scroll bg-gray-800">
                        <!-- Login user score  -->
                        <!-- <tr v-if="loginUserPoints && page == 1 && isTopUser" class="border-b bg-racing-stars-yellow text-black">
                            <td class="pl-2 md:pl-4 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md">
                                    {{ loginUserRank }}
                                </p>
                            </td>
                            <td class="flex my-1 max-w-1/3 py-1">
                                <span class="flex rounded-full shrink-0 mr-2 border border-1 border-gray-400">
                                    <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="loginUserPoints.profile_photo_url" :alt="loginUserPoints.username">
                                </span>
                                <p class="my-auto text-sm lg:text-lg truncate overflow-hidden">
                                    {{ loginUserPoints.username }}
                                </p>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ loginUserPoints.meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ loginUserPoints.points }}</td>
                        </tr> -->
                        <!-- All time  -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'alltime' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="pl-2 md:pl-4 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td>
                                <div class="flex mt-1 max-w-1/3 py-1">
                                    <span class="flex rounded-full shrink-0 mr-2">
                                        <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                    </span>
                                    <p class="my-auto text-sm lg:text-lg truncate overflow-hidden">
                                        {{ member.username }}
                                    </p>
                                </div>
                                <div v-if="Object.keys(member?.achievements).length > 0" class="flex items-center pb-2 ml-[30px]">
                                    <div v-for="(achievement, i) in member.achievements" :key="i" class="mx-1 text-center group relative w-10 h-10 bg-[#d0d0d0] rounded-full flex items-center justify-center">
                                        <img :src="achievement.achievement_badge.image" alt="" class="h-8 w-8 object-cover">
                                        <div class="hidden group-hover:block absolute -top-[47px] left-1/2 -translate-x-1/2 z-30">
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white text-nowrap">{{ achievement.achievement_badge.name }}</p>
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white">{{ achievement.progress }}</p>
                                            <div class="w-3 -mt-2 m-auto h-3  rotate-45 bg-black"></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.lifetime_meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.lifetime_points}}</td>                           
                        </tr>
                        <!-- Weekly -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'weekly' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="pl-2 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td>
                                <div class="flex mt-1 max-w-1/3 py-1">
                                    <span class="flex rounded-full shrink-0 mr-2">
                                        <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                    </span>
                                    <p class="my-auto">
                                        {{ member.username }}
                                    </p>
                                </div>
                                <div v-if="Object.keys(member?.achievements).length > 0" class="flex items-center pb-2 ml-[30px]">
                                    <div v-for="(achievement, i) in member.achievements" :key="i" class="mx-1 text-center group relative w-10 h-10 bg-[#d0d0d0] rounded-full flex items-center justify-center">
                                        <img :src="achievement.achievement_badge.image" alt="" class="h-8 w-8 object-cover">
                                        <div class="hidden group-hover:block absolute -top-[47px] left-1/2 -translate-x-1/2 z-30">
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white text-nowrap">{{ achievement.achievement_badge.name }}</p>
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white">{{ achievement.progress }}</p>
                                            <div class="w-3 -mt-2 m-auto h-3  rotate-45 bg-black"></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.weekly_meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.weekly_points}}</td>
                        </tr>
                        <!-- Daily -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'daily' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="pl-2 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td>
                                <div class="flex mt-1 max-w-1/3 py-1">
                                    <span class="flex rounded-full shrink-0 mr-2">
                                        <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                    </span>
                                    <p class="my-auto">
                                        {{ member.username }}
                                    </p>
                                </div>
                                <div v-if="Object.keys(member?.achievements).length > 0" class="flex items-center pb-2 ml-[30px]">
                                    <div v-for="(achievement, i) in member.achievements" :key="i" class="mx-1 text-center group relative w-10 h-10 bg-[#d0d0d0] rounded-full flex items-center justify-center">
                                        <img :src="achievement.achievement_badge.image" alt="" class="h-8 w-8 object-cover">
                                        <div class="hidden group-hover:block absolute -top-[47px] left-1/2 -translate-x-1/2 z-30">
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white text-nowrap">{{ achievement.achievement_badge.name }}</p>
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white">{{ achievement.progress }}</p>
                                            <div class="w-3 -mt-2 m-auto h-3  rotate-45 bg-black"></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center py-1 text-sm lg:text-lg">{{ member.daily_meetings }}</td>
                            <td class="text-center py-1 text-sm lg:text-lg">{{ member.daily_points}}</td>
                        </tr>
                        <!-- Monthly -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'monthly' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td>
                                <div class="flex mt-1 max-w-1/3 py-1">
                                    <span class="flex rounded-full shrink-0 mr-2">
                                        <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                    </span>
                                    <p class="my-auto">
                                        {{ member.username }}
                                    </p>
                                </div>
                                <div v-if="Object.keys(member?.achievements).length > 0" class="flex items-center pb-2 ml-[30px]">
                                    <div v-for="(achievement, i) in member.achievements" :key="i" class="mx-1 text-center group relative w-10 h-10 bg-[#d0d0d0] rounded-full flex items-center justify-center">
                                        <img :src="achievement.achievement_badge.image" alt="" class="h-8 w-8 object-cover">
                                        <div class="hidden group-hover:block absolute -top-[47px] left-1/2 -translate-x-1/2 z-30">
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white text-nowrap">{{ achievement.achievement_badge.name }}</p>
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white">{{ achievement.progress }}</p>
                                            <div class="w-3 -mt-2 m-auto h-3  rotate-45 bg-black"></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center py-1 text-sm lg:text-lg">{{ member.monthly_meetings }}</td>
                            <td class="text-center py-1 text-sm lg:text-lg">{{ member.monthly_points}}</td>
                        </tr>
                        <!-- Previous Week  -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'previous_week' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="pl-2 md:pl-4 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td class="flex my-1 max-w-1/3 py-1">
                                <span class="flex rounded-full shrink-0 mr-2">
                                    <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                </span>
                                <p class="my-auto text-sm lg:text-lg truncate overflow-hidden">
                                    {{ member.username }}
                                </p>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.previous_week_meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.previous_week_points}}</td>
                        </tr>
                        <!-- Previous Month  -->
                        <tr v-for="(member, index) in leaderBoards" :key="index" :class="[leaderboard === 'previous_month' ? '' : 'hidden', {'bg-racing-stars-yellow text-black': (page == 1 && isTopUser && loginUserPoints?.id == member?.id || loginUserPoints?.id == member?.id) }]" class="border-b bg-gray-900">
                            <td class="pl-2 md:pl-4 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md" :class="[+index + 1 + (page-1)*10 === 1 ? 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black' : '', +index + 1 + (page-1)*10 === 2 ? 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-black' : '', +index + 1 + (page-1)*10 === 3 ? 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-black' : '']">
                                    {{ +index + 1 + (page-1)*10 }}
                                </p>
                            </td>
                            <td class="flex my-1 max-w-1/3 py-1">
                                <span class="flex rounded-full shrink-0 mr-2">
                                    <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="member.profile_photo_url" :alt="member.username">
                                </span>
                                <p class="my-auto text-sm lg:text-lg truncate overflow-hidden">
                                    {{ member.username }}
                                </p>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.previous_month_meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ member.previous_month_points}}</td>
                        </tr>
                        <!-- Login user score  -->
                        <tr v-if="loginUserPoints && page == 1 && !isTopUser" class="border-b bg-racing-stars-yellow text-black">
                            <td class="pl-2 md:pl-4 lg:pl-7 py-1">
                                <p class="w-7 text-center rounded-md">
                                    {{ loginUserRank }}
                                </p>
                            </td>
                            <td>
                                <div class="flex mt-1 max-w-1/3 py-1">
                                    <span class="flex rounded-full shrink-0 mr-2 border border-1 border-gray-400">
                                        <img class="relative rounded-full mx-auto h-8 w-8 object-cover" :src="loginUserPoints.profile_photo_url" :alt="loginUserPoints.username">
                                    </span>
                                    <p class="my-auto text-sm lg:text-lg truncate overflow-hidden">
                                        {{ loginUserPoints.username }}
                                    </p>
                                </div>
                                <div v-if="loginUserAchievementData && loginUserAchievementData.length" class="flex items-center pb-2 ml-[30px]">
                                    <div v-for="(achievement, i) in loginUserAchievementData" :key="i" class="mx-1 text-center group relative w-10 h-10 bg-[#d0d0d0] rounded-full flex items-center justify-center">
                                        <img :src="achievement.achievement_badge.image" alt="" class="h-8 w-8 object-cover">
                                        <div class="hidden group-hover:block absolute -top-[47px] left-1/2 -translate-x-1/2 z-30">
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white text-nowrap">{{ achievement.achievement_badge.name }}</p>
                                            <p class="leading-[20px] bg-black py-1 px-3 text-white">{{ achievement.progress }}</p>
                                            <div class="w-3 -mt-2 m-auto h-3  rotate-45 bg-black"></div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ loginUserPoints.meetings }}</td>
                            <td class="text-center text-sm lg:text-lg py-1">{{ loginUserPoints.points }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="py-1"></div>
                    <div class="flex justify-center">
                        <v-pagination
                            v-model="page"
                            v-if="totalPages>1"
                            :pages="totalPages"
                            :range-size="1"
                            active-color="#fcea0d"
                            @update:modelValue="updateHandler"
                        />
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import AppLayout from '@/Layouts/Layout.vue';
import {ArrowLeftIcon, ArrowSmLeftIcon, ArrowSmRightIcon, EyeIcon, UserGroupIcon} from '@heroicons/vue/solid';
import JetInput from '@/Jetstream/Input.vue';
import JetTextarea from '@/Jetstream/Textarea.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetCheckbox from "@/Jetstream/Checkbox";
import {ref} from "vue";
import TwModal from '@/Global/Elements/TwModal.vue';
import _ from 'lodash';
import Multiselect from '@suadelabs/vue3-multiselect';
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
    props: {},

    data(){
        return{
            photoPreview: null,
            leaderboard: 'weekly'
        }
    },

    methods: {},

    setup() {
        const leaderBoards = ref([]);
        const loginUserPoints = ref([]);
        const loginUserRank = ref([]);
        const loginUserAchievementData = ref([]);
        const isTopUser = ref(false);
        const index = 1;
        const selectedLeague = ref(null);
        const leagueFilter = ref('Leaderboard');
        const itemsPerPage = ref(10);
        const page = ref(1);
        const totalPages = ref(0);
        const leaderboard = ref(window.location.href.indexOf('racingleague') > -1 || window.location.href.indexOf('rl') > -1 ? 'alltime' : 'weekly');

        const updateHandler = (value) => {
            page.value = value;
            changeLeaderboard();
        }

        const getNumberWithOrdinal = (runner, n) => {
            if (n === 0 && runner) {
                return runner.result.race_outcome_description;
            }

            var s = ['th', 'st', 'nd', 'rd'],
                v = n % 100;

            return n + (s[(v - 20) % 10] || s[v] || s[0]);
        }

        const sortedLeaderBoards = (leaderboard) => {
            return _.orderBy(leaderboard, leaderboard === 'alltime' ? 'lifetime_points' : 'weekly_points', 'desc');
        };

        const changeLeaderboard = () => {
            const selected = leaderboard.value;

            if (selected === "alltime") {
                axios.get(route("api.globalLeaderboard.forever", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.lifetime_points - a.lifetime_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints;
                    loginUserRank.value = response.data.loginUser.loginUserRank;
                    loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value);
                });
            }

            if (selected === "monthly") {
                axios.get(route("api.globalLeaderboard.monthly", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.monthly_points - a.monthly_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints;
                    loginUserRank.value = response.data.loginUser.loginUserRank;
                    loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value);
                });
            }

            if (selected === "weekly") {
                axios.get(route("api.globalLeaderboard.weekly", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.weekly_points - a.weekly_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints;
                    loginUserRank.value = response.data.loginUser.loginUserRank;
                    loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value);
                });
            }

            if (selected === "daily") {
                axios.get(route("api.globalLeaderboard.daily", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.daily_points - a.daily_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints || null;
                    loginUserRank.value = response.data.loginUser.loginUserRank || null;
                    loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value) || 0;
                });
            }

            if (selected === "previous_week") {
                axios.get(route("api.globalLeaderboard.previousWeek", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.previous_week_points - a.previous_week_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints || null;
                    loginUserRank.value = response.data.loginUser.loginUserRank || null;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value) || 0;
                });
            }

            if (selected === "previous_month") {
                axios.get(route("api.globalLeaderboard.previousMonth", { page: page.value }))
                .then((response) => {
                    const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.previous_month_points - a.previous_month_points);

                    leaderBoards.value = sortedValues;
                    loginUserPoints.value = response.data.loginUser.loginUserPoints || null;
                    loginUserRank.value = response.data.loginUser.loginUserRank || null;

                    if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                        isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                    }

                    totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value) || 0;
                });
            }
        };

        const checkUserInLeaderBoards = (loginUserPoints, leaderBoards) => {
            const loginUserId = loginUserPoints.id;
            const exists = leaderBoards.some(user => user.id === loginUserId);

            return exists;
        }

        const getLifeTimeLeague = () => {
            axios.get(route("api.globalLeaderboard.forever", { page: page.value }))
            .then((response) => {
                const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.lifetime_points - a.lifetime_points);

                leaderBoards.value = sortedValues;
                loginUserPoints.value = response.data.loginUser.loginUserPoints;
                loginUserRank.value = response.data.loginUser.loginUserRank;
                loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                    isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                }

                totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value);
            });
        }

        let routeName = "api.globalLeaderboard.weekly";

        if (window.location.href.indexOf('racingleague') > -1 || window.location.href.indexOf('rl') > -1) {
            routeName = "api.globalLeaderboard.forever";
        }

        axios.get(route(routeName, { page: page.value }))
            .then((response) => {
                const sortedValues = Object.values(response.data.leagueUsers).sort((a, b) => b.weekly_points - a.weekly_points);

                leaderBoards.value = sortedValues;
                loginUserPoints.value = response.data.loginUser.loginUserPoints;
                loginUserRank.value = response.data.loginUser.loginUserRank;
                loginUserAchievementData.value = response.data.loginUser.loginUserSelectedAchievementData;

                if(leaderBoards.value.length > 0 &&  loginUserPoints.value != null) {
                    isTopUser.value = checkUserInLeaderBoards(loginUserPoints.value, leaderBoards.value);
                }

                totalPages.value = Math.ceil(response.data.totalUsers/itemsPerPage.value);
            });

        return {
            leaderBoards,
            loginUserPoints,
            loginUserRank,
            loginUserAchievementData,
            isTopUser,
            changeLeaderboard,
            getLifeTimeLeague,
            index,
            sortedLeaderBoards,
            pageTitle: 'Leagues',
            selectedLeague,
            UserGroupIcon,
            getNumberWithOrdinal,
            itemsPerPage,
            totalPages,
            page,
            updateHandler,
            leaderboard,
            leagueFilter
        };
    },

    computed: {
        getUserId: {
            get() {
                return this.selectedLeague.owner_id;
            }
        }
    },

    components: {
        AppLayout,
        UserGroupIcon,
        EyeIcon,
        ArrowLeftIcon,
        ArrowSmLeftIcon,
        ArrowSmRightIcon,
        TwModal,
        JetInput,
        JetTextarea,
        JetInputError,
        JetButton,
        JetLabel,
        JetFormSection,
        JetCheckbox,
        ArrowSmRightIcon,
        Multiselect,
        VPagination
    },
}

</script>

